export default __webpack_public_path__ + "static/media/handmoon.50985b75.jpg";